module.exports = __webpack_public_path__ + "static/equipment-0374a0b3f7dde55362df1b606ef6b65a.svg";